module.exports = __webpack_public_path__ + "images/rimbaud-360427839d631343694a04099883c594.jpg";